/**
 * How DaVinci will handle each question, shown before the check (#469, homework-triage@1).
 *
 * Worked out without a model, from the confirmed transcription. It says how a question is HANDLED, never how it was
 * answered: not a grade, no count, no percentage. It never blocks the check.
 */

import type { HomeworkTriageResponse } from '@davinci/contracts';
import { useFeedbackLabels } from '../../i18n/homework-feedback-labels.js';
import { UntrustedText } from './untrusted-text.js';
import { useHomeworkLabels } from '../../i18n/homework-labels.js';

export function TriageList({ triage }: { readonly triage: HomeworkTriageResponse }): React.JSX.Element | null {
  const t = useFeedbackLabels();
  const h = useHomeworkLabels();
  if (triage.questions.length === 0) return null;
  return (
    <section className="triage-list" aria-labelledby="triage-heading">
      <h3 id="triage-heading">{t.triageHeading}</h3>
      <p>{t.triageIntro}</p>
      <ul className="plain-list">
        {triage.questions.map((question) => (
          <li key={question.questionLabel ?? ''} className={`triage-${question.triageClass}`}>
            <strong>
              {question.questionLabel === null ? (
                t.triageNoQuestion
              ) : (
                <>
                  {h.questionWord} <UntrustedText text={question.questionLabel} />
                </>
              )}
            </strong>
            {': '}
            {t.triageClassWord(question.triageClass)}
          </li>
        ))}
      </ul>
    </section>
  );
}
